import { cn } from '~/lib/utils';

interface LayeredButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
}

export default function LayeredButton({ text, className, ...props }: LayeredButtonProps) {
  return (
    <div className={cn('relative inline-block', className)}>
      {/* Háttér réteg */}
      <div className={cn(
        'absolute top-1 left-1 h-full w-full bg-[#E5D5B1]',
        // className,
      )}
      >
      </div>

      {/* Gomb réteg */}
      <button
        type={props.type}
        className={cn(
          'relative bg-[#B5331A] px-6 py-2 font-bold text-white shadow-md',
          // className,
        )}
        {...props}
      >
        {text}
      </button>
    </div>
  );
}
